/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_356e5812"]'><div :class='["radio-modal-cancel-btn-demo"]'><cube-radio-modal ref="__mpx_ref_radioModal__" title="关闭按钮配置" subtitle='你可以通过设置"cancelText"来显示关闭文案，同时将"cancelBtnAlign"设置为"right"' cancelText="关闭" cancelBtnAlign="right" :options="(options)" :value="(checkedValue)"/><cube-button @_click="onTap">radio-modal-cancel-btn</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_356e5812"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_356e5812"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_356e5812"}
  /** script content **/
  require("./radio-modal-cancel-btn.mpx.js?isComponent&outputPath=components%2Fradio-modal-cancel-btn356e5812%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./radio-modal-cancel-btn.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fradio-modal-cancel-btn356e5812%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_356e5812"],
    ctorType: "component",
    outputPath: "components/radio-modal-cancel-btn356e5812/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-radio-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio-modal/index.mpx?isComponent&outputPath=components%2Findex253dfa48%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>